import { connect } from 'react-redux'

import {
  getProjects,
  setprojectStatusList,
  setprojectCountryList,
  setSortBy,
  projectInput,
  setIsOrganicOnly,
  setIsManagedOnly,
  submitFilters,
} from 'reduxpath/ducks/Project/List'

import { setSelectedCountry, setSelectedProjectStatus } from 'reduxpath/ducks/Reference'

import SearchBox from './units'

const mapStateToProps = state => ({
  orderStatus: state.Reference.statusDefinition.order,
  selectedProjectStatus: state.Reference.selectedProjectStatus,
  searchProjectBrand: state.ProjectList.searchProjectBrand,
  sortBy: state.ProjectList.sortBy,
  selectionsCountry: state.Reference.selectionsCountry,
  selectedCountry: state.Reference.selectedCountry,
  isOrganicOnly: state.ProjectList.isOrganicOnly,
  isManagedOnly: state.ProjectList.isManagedOnly,
  param: {
    searchProjectBrand: state.ProjectList.searchProjectBrand,
    projectStatus: state.ProjectList.projectStatus,
    projectCountry: state.ProjectList.projectCountry,
    sortBy: state.ProjectList.sortBy,
    isOrganicOnly: state.ProjectList.isOrganicOnly,
    isManagedOnly: state.ProjectList.isManagedOnly,
  },
})

const mapDispatchToProps = dispatch => ({
  handleSelectedCountry() {
    return (e) => {
      e.preventDefault()
      dispatch(setSelectedCountry(e.target.value))
      dispatch(setprojectCountryList(e.target.value))
      dispatch(submitFilters())
    }
  },
  onInputChange(e) {
    e.preventDefault()
    dispatch(projectInput(e.target.value))
    dispatch(submitFilters())
  },

  handleSelectedProjectStatus() {
    return (e) => {
      e.preventDefault()
      dispatch(setSelectedProjectStatus(e.target.value))
      dispatch(setprojectStatusList(e.target.value))
      dispatch(submitFilters())
    }
  },
  handleSelectedSortBy() {
    return (e) => {
      e.preventDefault()
      dispatch(setSortBy(e.target.value))
      dispatch(submitFilters())
    }
  },

  checkBoxFilter(param) {
    return (e) => {
      let inputIsOrganic = false
      let inputIsManaged = false
      if (e.target.name === 'isOrganic') {
        dispatch(setIsOrganicOnly())
        inputIsOrganic = e.target.checked
      }

      if (e.target.name === 'isManaged') {
        dispatch(setIsManagedOnly(e.target.checked))
        inputIsManaged = e.target.checked
      }

      const {
        searchProjectBrand,
        projectStatus,
        projectCountry,
        sortBy,
        isOrganicOnly,
        isManagedOnly,
      } = param

      const qs = {
        sort: `${sortBy} DESC`,
        skip: 0,
        limit: 10,
        where: {
          or: [
            { name: { like: `%${searchProjectBrand}%` } },
            { brand: { like: `%${searchProjectBrand}%` } },
            { firstName: { like: `%${searchProjectBrand}%` } },
            { email: { like: `${searchProjectBrand}%` } },
          ],
        },
      }

      if (searchProjectBrand === qs.where.name) {
        qs.where.name = searchProjectBrand
      } else if (searchProjectBrand === qs.where.brand) {
        qs.where.brand = searchProjectBrand
      }

      if (projectStatus) {
        qs.where.status = projectStatus
      }
      if (projectCountry) {
        qs.where.country = projectCountry
      }

      if (e.target.name === 'isOrganic') {
        if (inputIsOrganic) {
          qs.where.isOrganic = inputIsOrganic
        }

        if (isManagedOnly) {
          qs.where.isManaged = isManagedOnly
        }
      }

      if (e.target.name === 'isManaged') {
        if (isOrganicOnly) {
          qs.where.isOrganic = isOrganicOnly
        }

        if (inputIsManaged) {
          qs.where.isManaged = inputIsManaged
        }
      }

      dispatch(getProjects(qs))
    }
  },
})

function mergeProps(stateProps, dispatchProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    checkBoxFilter: dispatchProps.checkBoxFilter(stateProps.param),
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SearchBox)
